<template>
  <el-dialog
    :append-to-body="true"
    :title="$t('product.供应商列表')"
    width="60%"
    :visible.sync="dialog.visible"
  >
    <div class="flex-box">
      <div>
        <div>{{$t('product.商品名称：')}}{{ dialog.data.name }}</div>
        <div class="mb-2">{{$t('product.商品SKU：')}}{{ dialog.data.sku }}</div>
      </div>
      <div>
        <el-button size="small" class="mb-2" type="primary" @click="addSupplier"
          >{{$t('product.添加供应商')}}</el-button
        >
      </div>
    </div>
    <el-dialog :append-to-body="true" :title="$t('product.添加供应商')" :visible.sync="addSupplierdialog">
      <el-form :model="addSupplierList" label-width="120px">
        <el-form-item :label="$t('product.供应商名称')">
            <el-autocomplete
                v-model="addSupplierList.name"
                :fetch-suggestions="querySearchAsync"
                :placeholder="$t('product.请输入供应商名称')"
              ></el-autocomplete>
        </el-form-item>
        <el-form-item :label="$t('product.供应商报价')">
          <el-input oninput="value=value.replace(/[^0-9.]/g,'')" v-model="addSupplierList.price" :placeholder="$t('请输入供应商报价')"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button size="small" type="primary" @click="onSubmit">{{$t('product.添加')}}</el-button>
            <el-button size="small" @click="cancel">{{$t('product.取消')}}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-table
      :data="supplierMoreData"
      style="width: 100%"
      size="small"
      :header-cell-style="{ background: '#FAFAFA' }"
    >
      <el-table-column prop="name" :label="$t('product.供应商')" align="center">
      </el-table-column>
      <el-table-column prop="price" :label="$t('product.采购价')" align="center">
        <template slot-scope="scope">
          <span> ￥{{ Number(scope.row.price).toFixed(2) }} </span>
        </template>
      </el-table-column>
      <el-table-column prop="address" :label="$t('product.地址')" align="center">
      </el-table-column>
      <el-table-column :label="$t('product.操作')">
        <template slot-scope="scope">
          <el-link
            disabled
            v-if="scope.row.default == '1'"
            class="text-info mr-4"
            >{{$t('product.当前默认')}}</el-link
          >
          <el-link
            v-if="scope.row.default != '1'"
            class="text-primary mr-4"
            @click.native="configDefaulit(scope.row)"
            >{{$t('product.设置默认')}}</el-link
          >
          <el-link
            v-if="scope.row.default != '1'"
            class="text-danger"
            type="danger"
            @click.native="del(scope.row)"
            >{{$t('product.删除')}}</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="close">{{$t('product.关闭')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  components: {
    // supplierSelect,
  },
  props: {
    dialog: {
      type: Object,
      default: function() {
        return {
          visible: false,
          data: {},
          supplierMoreData: [],
        };
      },
    },
  },
  data() {
    return {
      addSupplierdialog: false,
      restaurants: [],
      addSupplierList: {
        name: "",
        id: "",
        price: "",
      },
      rawStockSupplierIds: '',
      data: this.dialog.data,
      supplierMoreData: this.dialog.supplierMoreData,
    };
  },
  watch: {
    dialog: {
      deep: true,
      handler: function() {
        this.data = this.dialog.data;
        this.supplierMoreData = this.dialog.supplierMoreData;
      },
    },
  },
  methods: {
      close(){
          this.$emit('close', true)
      },
    querySearchAsync(queryString, cb) {
      if (!queryString) {
        return false;
      }
      $.api_call(
        "api.SupplierProductStock.findRawSupplierByName",
        {
          name: queryString,
        },
        (r) => {
          if (r.ErrorCode == "9999") {
            if(r.Data.Results.length == 0){
              ShowTip(this.$t('product.搜索不到数据'), "danger");
            }
            this.restaurants = r.Data.Results;
            var results = queryString
              ? this.restaurants.filter(
                  (item) => item.name.indexOf(queryString) > -1
                )
              : this.restaurants;
            results = results.map((item) => ({ value: item.name }));
            cb(results);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      );
    },
    addSupplier() {
      this.addSupplierdialog = true;
    },
    onSubmit() {
      this.restaurants.forEach((item) => {
        if (item.name == this.addSupplierList.name) {
          this.rawStockSupplierIds = item.id;
        }
      });
      $.api_call(
        "api.SupplierProductStock.bindRawSupplierByRawStock",
        {
          stockId: this.dialog.data.id,
          rawStockSupplierId: this.rawStockSupplierIds,
          price: this.addSupplierList.price,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            this.addSupplierdialog = false;
            this.addSupplierList.name = "";
            this.addSupplierList.price = "";
            ShowTip(this.$t("transfer.操作成功"), "success");
            this.checkMoreSupplier();
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      );
    },
    checkMoreSupplier() {
      this.loading = true;
      $.api_call(
        "api.SupplierProductStock.findRawSuppliersByRawStock",
        {
          stockId: this.dialog.data.id,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            this.supplierMoreData = r.Data.Results;
            console.log(this.supplierMoreData);
          }
        }
      );
    },
    configDefaulit(row){
        $.api_call(
        "api.SupplierProductStock.changeRawDefaultSupplier",
        {
          stockId: this.dialog.data.id,
          rawStockSupplierId: row.id,
          id: row.relationId
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
              ShowTip(this.$t("transfer.操作成功"), "success");
              this.checkMoreSupplier()
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      );
    },
    cancel() {
      this.addSupplierdialog = false;
      this.addSupplierList.name = "";
      this.addSupplierList.address = "";
      this.addSupplierList.price = "";
    },
    del(row){
        $.api_call(
        "api.SupplierProductStock.unbindRawSupplierByRawStock",
        {
          stockId: this.dialog.data.id,
          rawStockSupplierId: row.id,
          id: row.relationId
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(this.$t("transfer.操作成功"), "success");
            this.checkMoreSupplier()
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      );
    },
  },
};
</script>

<style scoped>
.flex-box {
  display: flex;
  justify-content: space-between;
}
</style>
